import {
  telRegex,
  zipCode,
  cityRegex,
  noSpecialCharsRegex
} from '../../../regex';

const requis = '^Ce champ est requis';
const maxMessage = 'Le champ ne doit pas contenir plus de ';

export const formCreateLyceeSchema = {
  name: {
    presence: { allowEmpty: false, message: requis },
    length: {
      maximum: 64,
      message: `^${maxMessage} 64 caractères`
    },
    format: {
      pattern: noSpecialCharsRegex,
      message: `^Le nom ne doit pas comporter de caractères spéciaux`
    }
  },
  ville: {
    presence: { allowEmpty: false, message: requis },
    format: {
      pattern: cityRegex,
      message: ' ne doit pas comporter de caractères spéciaux'
    },
    length: {
      maximum: 32,
      message: `^${maxMessage} 32 caractères`
    }
  },
  codepostal: {
    presence: { allowEmpty: false, message: requis },
    length: {
      is: 5,
      message: `^Le code postal doit contenir 5 chiffres.`
    },
    format: {
      pattern: zipCode,
      message: '^Le code postal ne doit contenir que des chiffres'
    }
  },
  adresse: {
    presence: { allowEmpty: false, message: requis },
    length: {
      maximum: 128,
      message: `^${maxMessage} 128 caractères`
    },
    format: {
      pattern: noSpecialCharsRegex,
      message: `^L'adresse ne doit pas comporter de caractères spéciaux`
    }
  },
  tel: {
    presence: { allowEmpty: false, message: requis },
    length: {
      is: 10,
      message: `^Le numéro de téléphone doit contenir 10 chiffres.`
    },
    format: {
      pattern: telRegex,
      message: '^Vous devez renseignez un numéro de téléphone'
    }
  },
  academie: {
    presence: { allowEmpty: false, message: requis }
  }
};
